import React, { ReactNode } from 'react';

import { useAutoNavigate } from '@betterment/js-runtime';
import { IconButton } from '@betterment/samba-react';
import { useLocation } from 'react-router-dom';

import { FlowLayout } from './FlowLayout';

import urlBuilder from '../../../Shared/url-builder';
import { FirmLogo } from '../../FirmLogo';
import { FullPageLoader } from '../../FullPageLoader';

interface OnDemandBillingFlowProps {
  children: ReactNode;
}

export const OnDemandBillingFlow = ({ children }: OnDemandBillingFlowProps) => {
  const navigate = useAutoNavigate();
  const location = useLocation();

  const isStartPage = location.pathname === urlBuilder.getOnDemandBillingStartPage.absolutePath;
  const isFlowPage = location.pathname.includes('/flow/');

  const getLeadingContent = () => {
    if (isStartPage) {
      return <FirmLogo />;
    }

    if (isFlowPage) {
      return (
        <IconButton
          name="LeftArrow"
          label="Back"
          spacing="compact"
          onClick={() => void navigate(urlBuilder.getOnDemandBillingStartPage.absolutePath)}
        />
      );
    }

    return null;
  };

  return (
    <React.Suspense fallback={<FullPageLoader />}>
      <FlowLayout leading={getLeadingContent()}>{children}</FlowLayout>
    </React.Suspense>
  );
};
